import HomepageIcon from '@material-ui/icons/Home';

export default {
  icon: HomepageIcon,
}